:host {
  display: block;
}
.general{
  display: flex;
  .left{
    max-width: 256px;
    border-right: 1px solid lightgray;
    padding: 1em;
    img{
      width: 100%;
    }
  }
  .right{
    padding: 1em;
  }
}

.form{
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: flex-end;
  label{
    font-weight: bold;
    text-align: right;
    margin-right: 0.5em;
    &::after{
      content: ':';
    }
    align-self: flex-start;
  }
  input, textarea{
    margin-top: 0.5em;
  }
}

.controls{
  margin-top: 2em;
  display: flex;
  justify-content: flex-end;
  gap: 1em;
}
